// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"408":"song","571":"settings"}[chunkId] + "." + {"408":"acdfac3a165b2c6c83a9","571":"4ec5fa19f8de3205e125"}[chunkId] + ".js";
};